const cards = require('./cards.jpg');

export {
  cards
}
